import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { App } from 'data/terra/App';
import { Market } from 'data/terra/Market';
import { Platform } from 'data/terra/Platform';
import { Product } from 'data/terra/Product';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { AppSelectorState } from '../reducer';

export const ADD_APPLICATION = 'ADD_APPLICATION';

export interface AddApplicationAction {
  type: typeof ADD_APPLICATION;
  app: App;
}

export const addApplication = (
  description: string,
  product: Product,
  platform: Platform,
  market: Market
): ThunkAction<void, RootState, unknown, Action<string>> => async dispatch => {
  // create new app
  const result = await Terra.app.addApp({
    description,
    product: { id: product.id },
    platform: { id: platform.id },
    market: { id: market.id },
  });
  if (result.isSuccess()) {
    dispatch({
      type: ADD_APPLICATION,
      app: result.get()!.data,
    } as AddApplicationAction);
  }

  return result;
};

export const addAppDelegate: DelegateMapEntry<
  AddApplicationAction,
  AppSelectorState
> = {
  [ADD_APPLICATION]: (
    state: AppSelectorState,
    action: AddApplicationAction
  ): AppSelectorState => {
    return {
      ...state,
      apps: [...state.apps, action.app],
    };
  },
};
